var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser6Line = function SvgUser6Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 16.5c3.296 0 6.178 1.418 7.746 3.532l-1.657.784C16.811 19.304 14.561 18.3 12 18.3s-4.812 1.004-6.088 2.516l-1.657-.784C5.822 17.917 8.705 16.5 12 16.5M12 3a4.5 4.5 0 0 1 4.5 4.5v2.7a4.5 4.5 0 0 1-4.305 4.495L12 14.7a4.5 4.5 0 0 1-4.5-4.5V7.5a4.5 4.5 0 0 1 4.305-4.495zm0 1.8a2.7 2.7 0 0 0-2.695 2.542L9.3 7.5v2.7a2.7 2.7 0 0 0 5.395.158l.005-.158V7.5A2.7 2.7 0 0 0 12 4.8"
  })));
};
export default SvgUser6Line;